"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* istanbul ignore file -- remove once added tests */
const clsx_1 = __importDefault(require("clsx"));
const ImageTile_module_css_1 = __importDefault(require("./ImageTile.module.css"));
/**
 * Image tile for lens previews
 */
function ImageTile(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(ImageTile_module_css_1.default.tileContainer), "data-testid": "image-tile", children: [props.imageSrc && ((0, jsx_runtime_1.jsx)("div", { className: ImageTile_module_css_1.default.imageWrapper, style: { height: props.height }, children: (0, jsx_runtime_1.jsx)("img", { className: (0, clsx_1.default)(ImageTile_module_css_1.default.tileMedia), height: props.height, width: props.width, src: props.imageSrc, alt: props.alt || "", "data-testid": "image-tile-img" }) })), (0, jsx_runtime_1.jsx)("div", { className: ImageTile_module_css_1.default.overlay, children: props.children })] }));
}
exports.ImageTile = ImageTile;
//# sourceMappingURL=ImageTile.js.map